import React from "react";

const Dipchart = () => {
  return <div>Coming Soon</div>;
};

export default Dipchart;
